export interface ParsedAgentSummary {
  fields: { key: string; label: string; value: string }[];
  conversationLog: { role: string; content: string }[] | null;
  attachments: string[] | null;
}

export function parseAgentSummary(summary: string): ParsedAgentSummary {
  const fields: ParsedAgentSummary["fields"] = [];
  let conversationLog: ParsedAgentSummary["conversationLog"] = null;
  let attachments: ParsedAgentSummary["attachments"] = null;

  for (const match of summary.matchAll(/\[(\w+)\]:?\s*([\s\S]*?)\s*\[\/\1\]/g)) {
    const [, key, rawValue] = match;
    const value = rawValue.trim();

    if (key === "Conversation_Log") {
      conversationLog = Array.from(
        value.matchAll(/\[(\w+)\]([\s\S]*?)\[\/\1\]/g),
        (turn) => ({ role: turn[1], content: turn[2].trim() })
      );
    } else if (key === "Attachments") {
      attachments = value
        .split(/\r?\n/)
        .map((line) => line.replace(/^[-*]\s*/, "").trim())
        .filter(Boolean);
    } else {
      fields.push({
        key,
        label: key === "Case_ID" ? "Case ID" : key.replace(/_/g, " "),
        value,
      });
    }
  }

  return { fields, conversationLog, attachments };
}